import React from 'react';
import styled from 'styled-components';

import { Button } from './Button';
import { Modal } from './Modal';

const CloseSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#939090" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 10.586L16.95 5.636L18.364 7.05L13.414 12L18.364 16.95L16.95 18.364L12 13.414L7.05005 18.364L5.63605 16.95L10.586 12L5.63605 7.05L7.05005 5.636L12 10.586Z"
      fill="#939090"
    />
  </svg>
);

const Container = styled.form`
  padding: 16px 16px 8px;
  margin: 1rem;
  border-radius: 4px;
  width: 580px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 8px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.4px;
  color: #000000;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 12px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
`;

type Props = Partial<{
  onClose?: () => void;
  onSubmit?: () => void;
  title: string;
  isSubmitting?: boolean;
  isValid?: boolean;
  cancelButtonProps?: Partial<{
    label: string;
    onClick: () => void;
  }>;
  confirmButtonProps?: {
    label?: string;
    onClick?: () => void;
  };
  children: React.ReactNode;
}>;

export const FormModal: React.FC<Props> = (props) => {
  return (
    <Modal>
      <Container
        onSubmit={(e) => {
          e.preventDefault();

          if (props.isSubmitting) return;
          props.onSubmit && props.onSubmit();
        }}
      >
        <Header>
          <Title>{props.title}</Title>
          <CloseButton
            onClick={() => {
              if (props.isSubmitting) return;

              if (props.cancelButtonProps?.onClick) {
                props.cancelButtonProps.onClick();
              } else {
                props.onClose?.();
              }
            }}
          >
            <CloseSvg />
          </CloseButton>
        </Header>
        <Content>{props.children}</Content>
        <Footer>
          <Button
            onClick={() => {
              if (props.isSubmitting) return;

              if (props.cancelButtonProps?.onClick) {
                props.cancelButtonProps.onClick();
              } else {
                props.onClose?.();
              }
            }}
            icon=""
            size="small"
            variant="secondary"
            disabled={props.isSubmitting}
          >
            {props.cancelButtonProps?.label || 'Cancelar'}
          </Button>
          <Button
            loading={props.isSubmitting}
            disabled={!props.isValid || props.isSubmitting}
            onClick={() => {
              if (props.isSubmitting) return;
              props.confirmButtonProps?.onClick?.();
            }}
            icon=""
            size="small"
          >
            {props.confirmButtonProps?.label || 'Salvar'}
          </Button>
        </Footer>
      </Container>
    </Modal>
  );
};
